// DE
export const reservasHc = {
  // ── CheckinsList.vue ──────────────────────────────────────────────────────
  checkinsList: {
    newCheckin: "Neuer Check-in",
    manualDispatchTitle: "Manueller Abschluss der Endübermittlung",
    manualDispatchText:
      "Wenn einer der Gäste nicht anreist, können Sie diesen Vorgang manuell abschließen, um dem Buchungsinhaber jetzt die Willkommensnachricht, die digitalen Schlüssel und das Dokument zu senden.",
    sending: "Wird gesendet...",
    completeManualSend: "Manuell abschließen und senden",
    finalSendProcessed: "Endübermittlung bereits verarbeitet",
    arrivalInstructions: "Anreiseinformationen",
    arrivalAlreadySent: "Bereits gesendet. Sie können sie dem Gast bei Bedarf jetzt erneut senden.",
    arrivalAutoInfo:
      "Sie werden automatisch zum geplanten Zeitpunkt gesendet. Sie können sie vorziehen und jetzt senden (Nachricht, Zugang und eingerichtete Dateien).",
    resendNow: "Jetzt erneut senden",
    sendNow: "Jetzt senden",

    titleEditCheckin: "Check-in bearbeiten",
    titleDeleteCheckin: "Check-in löschen",

    confirmManualTitle: "Übermittlung manuell abschließen?",
    confirmManualMsg:
      "Verwenden Sie diese Aktion, wenn keine weiteren Gäste einchecken und Sie dem Buchungsinhaber jetzt die abschließenden Informationen senden möchten.",
    yesSendNow: "Ja, jetzt senden",
    cancel: "Abbrechen",
    manualSendFailed: "Die manuelle Übermittlung konnte nicht abgeschlossen werden.",
    sendProcessedTitle: "Übermittlung verarbeitet",
    finalInfoProcessed: "Die abschließenden Check-in-Informationen wurden bereits verarbeitet.",
    couldNotSend: "Senden nicht möglich",

    confirmResendArrivalTitle: "Anreiseinformationen erneut senden?",
    confirmSendArrivalTitle: "Anreiseinformationen jetzt senden?",
    confirmResendArrivalMsg:
      "Die Anreiseinformationen wurden bereits gesendet. Möchten Sie sie dem Gast jetzt erneut senden?",
    confirmSendArrivalMsg:
      "Die Anreiseinformationen (Nachricht, Zugang und eingerichtete Dateien) werden dem Gast jetzt gesendet, ohne den geplanten Zeitpunkt abzuwarten.",
    arrivalSendFailed: "Die Anreiseinformationen konnten nicht gesendet werden.",
    pendingDeliveryTitle: "Übermittlung ausstehend",
    instructionsSentTitle: "Informationen gesendet",
    arrivalSentToGuest: "Die Anreiseinformationen wurden dem Gast gesendet.",

    stepGuestData: "Gastdaten",
    stepSignature: "Unterschrift",
    stepRegistered: "Check-in erfasst",

    sectionPersonal: "Persönliche Daten",
    sectionStay: "Aufenthalt",
    sectionDocument: "Dokument",

    nombre: "Vorname",
    apellido: "Nachname",
    sexo: "Geschlecht",
    select: "Auswählen",
    male: "Männlich",
    female: "Weiblich",
    preferNotToSay: "Keine Angabe",
    other: "Andere",
    birthDate: "Geburtsdatum",
    minorsTraveling: "Reisen Minderjährige mit dieser Buchung?",
    no: "Nein",
    yes: "Ja",
    relationshipMinor: "Verwandtschaft des Minderjährigen",
    relationshipToMinor: "Verwandtschaft zum Minderjährigen",
    phone: "Telefon",
    email: "E-Mail",
    checkInDate: "Check-in-Datum",
    checkOutDate: "Check-out-Datum",

    nationality: "Staatsangehörigkeit",
    cittadinanza: "Cittadinanza / Staatsangehörigkeit",
    documentType: "Dokumenttyp",
    documentNumber: "Dokumentnummer",
    supportNumber: "Trägernummer",
    docTypes: {
      passport: "Reisepass",
      identityDoc: "Ausweisdokument",
      co_cc: "Bürgerausweis",
      co_ce: "Ausländerausweis",
      co_ppt: "Vorübergehende Schutzerlaubnis",
      co_pep: "Besondere Aufenthaltserlaubnis",
      co_de: "Ausländisches Dokument",
    },
    relationships: {
      co: {
        PADRE: "Vater",
        MADRE: "Mutter",
        HIJO: "Sohn/Tochter",
        ABUELO: "Großvater/Großmutter",
        HERMANO: "Bruder/Schwester",
        TIO: "Onkel/Tante",
        TUTOR: "Gesetzlicher Vormund",
        OTRO: "Andere",
      },
      es: {
        HJ: "Sohn/Tochter",
        AB: "Großvater/Großmutter",
        BA: "Urgroßvater/-mutter",
        BN: "Urenkel/-in",
        CD: "Schwager/Schwägerin",
        CY: "Ehepartner/-in",
        HR: "Bruder/Schwester",
        NI: "Enkel/-in",
        OT: "Andere",
        PM: "Vater/Mutter",
        SB: "Neffe/Nichte",
        SG: "Schwiegervater/-mutter",
        TI: "Onkel/Tante",
        TU: "Vormund",
        YN: "Schwiegersohn/-tochter",
      },
    },

    italyBannerTitle: "In Italien erforderliche Daten · Alloggiati Web",
    italyBannerText:
      "Die Polizia di Stato verlangt den Geburtsstaat, die Geburtsgemeinde und den Ausstellungsort des Dokuments.",
    sectionBirthData: "Geburtsdaten",
    statoNascita: "Stato di nascita / Geburtsland",
    birthStateHint: "Der Geburtsstaat kann von der Staatsangehörigkeit abweichen.",
    comuneNascita: "Geburtsgemeinde",
    luogoRilascio: "Ausstellungsort des Dokuments",
    luogoRilascioHint: "Italienische Gemeinde oder ausländischer Staat, der das Dokument ausgestellt hat.",
    searchCittadinanza: "Staatsangehörigkeit suchen…",
    searchStatoNascita: "Geburtsstaat suchen…",
    searchComuneNascita: "Geburtsgemeinde suchen…",
    searchComuneRilascio: "Ausstellungsgemeinde…",
    searchStatoRilascio: "Ausstellungsstaat…",

    sectionSes: "Daten für SES Hospedajes",
    countryResidence: "Wohnsitzland",
    cityResidence: "Wohnort",
    address: "Adresse",
    zipCode: "PLZ",
    paymentMethod: "Zahlungsart",
    paymentDate: "Zahlungsdatum",
    pay: {
      efectivo: "Bargeld",
      destino: "Zahlung vor Ort",
      tarjeta: "Karte",
      movil: "Mobile Zahlung",
      plataforma: "Plattform",
      transferencia: "Banküberweisung",
    },

    sireLegalTitle: "SIRE & TRA: Rechtlicher Hinweis",
    sireLegalText:
      "Für Betriebe in Kolumbien werden die angeforderten Daten gemäß den Vorschriften von Migración Colombia (SIRE) und des Gästeregisters (TRA) erhoben.",
    sectionSire: "Daten für SIRE / TRA",
    searchNationality: "Staatsangehörigkeit suchen...",
    searchCountry: "Land suchen...",
    noResults: "Keine Ergebnisse",
    countryOrigin: "Herkunftsland",
    searchCountryOrigin: "Herkunftsland suchen...",
    cityOrigin: "Herkunftsstadt",
    searchCity: "Stadt suchen...",
    searchMunicipality: "Gemeinde suchen...",
    nextDestinationCountry: "Nächstes Zielland",
    searchDestinationCountry: "Zielland suchen...",
    summaryOrigin: "Herkunft",
    summaryDestination: "Ziel",

    sectionIdentity: "Identitätsprüfung",
    recommended: "empfohlen",
    identityActiveInfo:
      "Für diese Unterkunft ist die Identitätsprüfung aktiviert. Laden Sie Fotos des Ausweises des Gastes hoch.",
    documentFront: "Vorderseite des Dokuments",
    uploadPhoto: "Foto hochladen",
    selfieGuest: "Selfie des Gastes",
    altDocumentFront: "Vorderseite des Dokuments",
    altMinorAuth: "Einverständnis für Minderjährige",
    titleRemove: "Entfernen",

    sectionMinorDocs: "Unterlagen für Minderjährige",
    optional: "optional",
    minorInfo: "Für Minderjährige können Sie die Reiseerlaubnis oder das Dokument des Erziehungsberechtigten hochladen.",
    guardianAuthDoc: "Einverständnis / Dokument des Erziehungsberechtigten",
    uploadDocument: "Dokument hochladen",

    sectionSignature: "Unterschrift des Gastes",
    signatureHint: "Bitten Sie den Gast, im Feld zu unterschreiben, um die Bedingungen der Unterkunft zu akzeptieren.",
    undo: "Rückgängig",
    clear: "Leeren",
    termsAccept: "Der Gast akzeptiert die Bedingungen der Unterkunft",

    successTitle: "Check-in erfasst!",
    successBefore: "Der Check-in von",
    successAfter: "wurde erfolgreich gespeichert.",

    next: "Weiter",
    back: "Zurück",
    saving: "Wird gespeichert...",
    saveCheckin: "Check-in speichern",
    close: "Schließen",

    vNombre: "Vorname ist erforderlich",
    vApellido: "Nachname ist erforderlich",
    vSexo: "Geschlecht ist erforderlich",
    vBirthDate: "Geburtsdatum ist erforderlich",
    vPhone: "Telefon ist erforderlich",
    vCheckIn: "Check-in-Datum ist erforderlich",
    vCheckOut: "Check-out-Datum ist erforderlich",
    vNationality: "Staatsangehörigkeit ist erforderlich",
    vDocType: "Dokumenttyp ist erforderlich",
    vDocNumber: "Dokumentnummer ist erforderlich",
    vEmailFormat: "Das E-Mail-Format ist ungültig",
    vDocSupport: "Die Trägernummer des Dokuments ist erforderlich",
    vMinors: "Geben Sie an, ob Minderjährige mit der Buchung reisen",
    vRelationship: "Die Verwandtschaft des begleiteten Minderjährigen ist erforderlich",
    vCountryResidence: "Wohnsitzland ist erforderlich",
    vCityResidence: "Wohnort ist erforderlich",
    vAddress: "Adresse ist erforderlich",
    vZip: "PLZ ist erforderlich",
    vPaymentMethod: "Zahlungsart ist erforderlich",
    vPaymentDate: "Zahlungsdatum ist erforderlich",
    vCountryOrigin: "Herkunftsland ist erforderlich",
    vNextDest: "Nächstes Zielland ist erforderlich",
    vCityOrigin: "Herkunftsstadt ist erforderlich",
    vStatoNascita: "Der Geburtsstaat (Stato di nascita) ist erforderlich",
    vComuneNascita: "Die Geburtsgemeinde (Comune di nascita) ist erforderlich",
    vLuogoRilascio: "Der Ausstellungsort des Dokuments (Luogo di rilascio) ist erforderlich",

    vTerms: "Sie müssen die Bedingungen akzeptieren, um fortzufahren",
    vSignaturePad: "Fehler beim Zugriff auf das Unterschriftenfeld",
    vSignature: "Die Unterschrift ist erforderlich",
    saveCheckinError: "Beim Speichern des Check-ins ist ein Fehler aufgetreten",
    saveCheckinErrorGeneric: "Fehler beim Speichern des Check-ins",
    socketCheckinDone: "<strong>{name}</strong> hat den manuellen Check-in abgeschlossen",
    identityPhotosError: "Der Check-in wurde gespeichert, aber die Fotos zur Identitätsprüfung konnten nicht hochgeladen werden",
    minorAuthError: "Der Check-in wurde gespeichert, aber das Einverständnis für den Minderjährigen konnte nicht hochgeladen werden",

    docDni: "Ungültiger DNI. Er muss 8 Ziffern und den passenden Prüfbuchstaben haben (z. B. 12345678Z)",
    docNie: "Ungültige NIE. Format: X/Y/Z + 7 Ziffern + Prüfbuchstabe (z. B. X1234567Z)",
    docPassport: "Ungültiger Reisepass. Er muss 6 bis 20 alphanumerische Zeichen haben",
    docCc: "Ungültiger Bürgerausweis. Er muss 6 bis 10 Ziffern haben",
    docCe: "Ungültiger Ausländerausweis. Er muss 6 bis 12 alphanumerische Zeichen haben",
    docPptPep: "Ungültig: {tipo}. Es muss 4 bis 15 alphanumerische Zeichen haben",

    zipNotFound: "PLZ nicht gefunden. Prüfen Sie die Nummer und versuchen Sie es erneut.",
  },

  // ── PageReservation.vue ───────────────────────────────────────────────────
  pageReservation: {
    holdLeftMinutes: "noch {min} Min. zum Bezahlen",
    holdLeftSeconds: "noch {seg} s zum Bezahlen",
    holdExpired: "die Frist ist abgelaufen: die Nächte wurden freigegeben",
    requestPendingTitle: "Buchungsanfrage ausstehend",
    requestPendingText:
      "Der Gast hat diese Daten angefragt. Der Kalender wird erst nach Ihrer Bestätigung gesperrt.",
    approving: "Wird bestätigt…",
    approve: "Bestätigen",
    rejecting: "Wird abgelehnt…",
    reject: "Ablehnen",
    requestRejectedTitle: "Anfrage abgelehnt",
    requestRejectedText: "Diese Anfrage wurde von der Unterkunft abgelehnt und kann nicht mehr bestätigt werden.",
    awaitingPaymentTitle: "Warten auf die Zahlung des Gastes",
    awaitingPaymentText:
      "Der Kalender ist vorübergehend gesperrt. Ohne Zahlung wird die Verfügbarkeit automatisch wieder freigegeben.",
    remaining: "verbleibend",
    marking: "Wird markiert...",
    markAsPaid: "Als bezahlt markieren",
    expiring: "Läuft ab...",
    markAsExpired: "Als abgelaufen markieren",

    extensionPendingTitle: "Verlängerung des Aufenthalts ausstehend",
    extraNights: "{count} zusätzliche Nacht/Nächte",
    newCheckout: "neues Check-out",
    awaitingGuestPayment: "Warten auf die Zahlung des Gastes",
    pendingApproval: "Bestätigung ausstehend",
    confirming: "Wird bestätigt...",

    observation: "Hinweis",

    pendingCharge: "Zahlung ausstehend",
    processing: "Wird verarbeitet...",

    clientRequested: "Der Kunde hat angefragt:",
    serviceFallback: "Leistung",
    toConsult: "auf Anfrage",

    approveRequestTitle: "Anfrage bestätigen",
    amountToCharge: "Zu berechnender Betrag",
    noCharge: "0 = keine Berechnung",
    approveHint:
      "Wenn ein Zahlungsanbieter verbunden ist, erhält der Gast einen <strong>Zahlungslink</strong> (WhatsApp + E-Mail). Andernfalls wird ihm mitgeteilt, dass er <strong>bei der Ankunft zahlt</strong>.",
    cancel: "Abbrechen",
    close: "Schließen",
    approveAndNotify: "Bestätigen und benachrichtigen",

    reservationTotal: "Buchungssumme:",
    onRequestPaidSeparately: `Positionen "auf Anfrage" werden separat bezahlt`,
    fullPayment: "Vollständige Zahlung",
    noBalance: "(kein Restbetrag)",
    deposit: "Anzahlung",
    balance: "Restbetrag",
    markPaidHint: `Der gewählte Betrag wird als kassiert erfasst. Die "Summe" umfasst Aufenthalt, Reinigung und bepreiste Leistungen (z. B. Uber); Positionen "auf Anfrage" werden separat berechnet.`,
    confirm: "Bestätigen",

    paymentExpiredTitle: "Zahlungsfrist abgelaufen",
    paymentExpiredText: "Die vorläufige Buchung ist abgelaufen und die Verfügbarkeit wurde automatisch freigegeben.",

    overbookingTitle: "Buchung im Overbooking",
    overbookingText:
      "Die Daten überschneiden sich mit einer anderen Buchung dieser Unterkunft. Die Daten bleiben auf den OTAs gesperrt. Wenn Sie den Konflikt bereits gelöst haben (andere Buchung storniert oder verschoben), bestätigen Sie hier.",
    verifying: "Wird geprüft...",
    confirmReservation: "Buchung bestätigen",

    checkinInvitation: "Check-in-Einladung",
    copyCheckinLink: "Check-in-Link kopieren",
    editReservation: "Buchung bearbeiten",

    codesAndAccess: "Codes und Zugang",
    codesAndAccessSub: "Zugangsschlüssel und Links des Gastes",
    currentAccessCodes: "Aktuelle Zugangscodes:",
    currentAccessCode: "Aktueller Zugangscode:",
    guestDigitalAccess: "Digitaler Zugang des Gastes",
    copyOpenLink: "Öffnungslink kopieren",
    copy: "Kopieren",
    openLink: "Öffnungslink öffnen",
    open: "Öffnen",
    yacanNote: "Den Zugang für diese Buchung verwaltet <b>YACAN</b> automatisch mit seinen Schlössern.",
    digitalKeyEkey: "Digitaler Schlüssel (ekey)",
    openDigitalKey: "Digitalen Schlüssel öffnen",
    previousCodesExpired: "Frühere Codes (bereits abgelaufen):",
    sentOn: "gesendet am",
    generated: "erstellt",
    expiredOn: "abgelaufen am",

    amountAndPayment: "Betrag und Zahlung",
    amountAndPaymentSub: "Aufschlüsselung, Zahlungsstatus und Rechnungsstellung",

    guestJourney: "Gästereise",
    eventsCount: "{count} Ereignis | {count} Ereignisse",
    journeySubtitle: "Vollständige Nachverfolgung von der Buchung bis zum Check-out",
    stagesCompleted: "Phasen abgeschlossen",
    nextLabel: "Nächster Schritt:",
    // Cabecera del bloque de etapas que aún no han ocurrido; van FUERA de la cronología.
    pendingAhead: "Was noch fehlt",
    // El envío del parte a las autoridades: cada servicio lo apunta en historial_firmas.
    authoritiesTitle: "Gästemeldung",
    authoritiesAction: "wurde den Behörden gemeldet",
    authoritiesDesc: "Gesendet an {services}",
    viewInChat: "Im Chat ansehen",

    accessCode: "Zugangscode",
    accessCodeSub: "Schlüssel bearbeiten und an den Gast senden",
    currentlyConfiguredCode: "Aktuell eingerichteter Code",
    newCode: "Neuer Code",
    keepSameToResend: "unverändert lassen, um ihn ohne Änderungen erneut zu senden",
    placeholderCode: "Z. B. ABCD1234",
    codeSavedUppercaseHint: "Der Code wird in Großbuchstaben gespeichert und per WhatsApp und/oder E-Mail gesendet.",
    sending: "Wird gesendet...",
    saveAndSendToGuest: "Speichern und an den Gast senden",

    resendAccess: "Zugang erneut senden",
    sendAccess: "Zugang senden",
    resendPin: "PIN erneut senden",
    sendPin: "PIN senden",
    activating: "Wird aktiviert...",
    resendCode: "Code erneut senden",
    sendAccessCode: "Zugangscode senden",

    channelManager: "Channel Manager",
    directBooking: "Direktbuchung",
    directTag: "Direkt",
    bookingRegistered: "Buchung erfasst",
    bookedViaOta: "über OTA gebucht",
    createdBooking: "hat die Buchung erstellt",
    incomingVia: "Eingang über {channel}",
    confirmedTag: "Bestätigt",
    pendingTag: "Ausstehend",
    bookingConfirmed: "Buchung bestätigt",
    pendingConfirmation: "Bestätigung ausstehend",
    receivedConfirmation: "hat die Buchungsbestätigung erhalten",
    awaitingConfirmationAction: "wartet auf die Bestätigung",
    propertyConfirmed: "Die Unterkunft hat die Buchung bestätigt",
    awaitingConfirmationDesc: "Warten auf die Bestätigung",
    sentTag: "Gesendet",
    notSentTag: "Nicht gesendet",
    checkinInvitationTitle: "Check-in-Einladung",
    receivedCheckinInvite: "hat die Check-in-Einladung erhalten",
    notReceivedCheckinInvite: "hat die Check-in-Einladung noch nicht erhalten",
    checkinLinkSent: "Check-in-Link an den Gast gesendet",
    inviteNotSentYet: "Die Einladung wurde noch nicht gesendet",
    completedTag: "Abgeschlossen",
    checkinOnline: "Online-Check-in",
    didCheckinOnline: "hat den Online-Check-in abgeschlossen",
    notYetCheckinOnline: "hat den Online-Check-in noch nicht abgeschlossen",
    guestsRegistered: "{count} Gast/Gäste erfasst",
    guestNotCompletedCheckin: "Der Gast hat den Check-in noch nicht abgeschlossen",
    sentTagPlural: "Gesendet",
    accessCodes: "Zugangscodes",
    receivedAccessCodes: "hat die Zugangscodes erhalten",
    notReceivedAccessCodes: "hat die Zugangscodes noch nicht erhalten",
    accessKeysSent: "Zugangsschlüssel an den Gast gesendet",
    pendingSendAccess: "Versand des Zugangs ausstehend",
    finishedTag: "Beendet",
    plannedTag: "Geplant",
    guestCheckout: "Check-out des Gastes",
    finishedStay: "hat den Aufenthalt beendet",
    plannedCheckout: "hat ein geplantes Check-out",
    stayFinished: "Der Aufenthalt ist beendet",
    autoCheckoutScheduled: "Automatisches Check-out geplant",
    theGuest: "Der Gast",
    theTeam: "Das Team",
    theChannel: "Der Kanal",
    theSystem: "Das System",
    calledFromNumber: "hat von der Nummer {phone} angerufen",

    filterAll: "Alle",
    filterWhatsapp: "WhatsApp",
    filterCalls: "Anrufe",
    filterCheckin: "Check-in",
    filterAccess: "Zugang",
    filterBooking: "Buchung",

    error: "Fehler",
    requestApprovedMsg: "Anfrage bestätigt. Die Buchung ist bestätigt.",
    requestApprovedTitle: "✓ Bestätigt",
    couldNotApprove: "Bestätigen nicht möglich.",
    confirmRejectRequestMsg: "Möchten Sie diese Anfrage wirklich ablehnen? Das lässt sich nicht rückgängig machen.",
    rejectRequestHeader: "Anfrage ablehnen",
    yesReject: "Ja, ablehnen",
    requestRejectedMsg: "Anfrage abgelehnt.",
    rejectedTitle: "Abgelehnt",
    couldNotReject: "Ablehnen nicht möglich.",
    couldNotLoadOptions: "Die Optionen konnten nicht geladen werden; es wird die Gesamtsumme markiert.",
    noticeTitle: "Hinweis",
    depositMarkedPaid: "Anzahlung als bezahlt markiert. Buchung mit offenem Restbetrag bestätigt.",
    fullMarkedPaid: "Buchung als vollständig bezahlt markiert und bestätigt.",
    paymentConfirmedTitle: "Zahlung bestätigt",
    couldNotMarkPaid: "Als bezahlt markieren nicht möglich.",
    tempReservationExpired: "Die vorläufige Buchung wurde beendet und die Verfügbarkeit freigegeben.",
    reservationExpiredTitle: "Buchung abgelaufen",
    couldNotMarkExpired: "Als abgelaufen markieren nicht möglich.",
    extensionMarkedPaid: "Die Verlängerung wurde als bezahlt markiert und bestätigt.",
    extensionConfirmedTitle: "Verlängerung bestätigt",
    couldNotConfirmExtension: "Die Verlängerung konnte nicht bestätigt werden.",
    extensionCancelled: "Die Verlängerung wurde storniert und die Verfügbarkeit freigegeben.",
    extensionRejectedTitle: "Verlängerung abgelehnt",
    couldNotRejectExtension: "Die Verlängerung konnte nicht abgelehnt werden.",
    chargeMarkedPaid: "Die Position wurde als bezahlt markiert.",
    chargeRegisteredTitle: "Zahlung erfasst",
    couldNotMarkChargePaid: "Die Position konnte nicht als bezahlt markiert werden.",
    chargeRejected: "Die Position wurde abgelehnt und aus der Buchung entfernt.",
    chargeRejectedTitle: "Position abgelehnt",
    couldNotRejectCharge: "Die Position konnte nicht abgelehnt werden.",
    approvedState: "Bestätigt",
    rejectedState: "Abgelehnt",
    paidState: "Bezahlt",
    pendingYourResponse: "Wartet auf Ihre Antwort",
    enterValidAmount: "Geben Sie einen gültigen Betrag ein (0 = keine Berechnung).",
    amountTitle: "Betrag",
    approvedPaymentLinkSent: "Bestätigt. Der Zahlungslink wurde an den Gast gesendet (WhatsApp + E-Mail).",
    serviceApprovedTitle: "Leistung bestätigt",
    approvedPayOnArrival: "Bestätigt. Der Gast zahlt bei der Ankunft (kein Zahlungsanbieter verbunden).",
    approvedGuestNotified: "Bestätigt. Der Gast wurde benachrichtigt.",
    couldNotApproveRequest: "Die Anfrage konnte nicht bestätigt werden.",
    requestRejectedNotified: "Anfrage abgelehnt. Der Gast wurde benachrichtigt.",
    serviceRejectedTitle: "Leistung abgelehnt",
    couldNotRejectRequest: "Die Anfrage konnte nicht abgelehnt werden.",
    resendAccessLinkMsg: "Möchten Sie den Zugangslink über die verfügbaren Kanäle erneut senden?",
    sendAccessLinkMsg: "Möchten Sie den Zugangslink über die verfügbaren Kanäle senden?",
    resendPinMsg:
      "Möchten Sie den Zugangscode über die verfügbaren Kanäle erneut senden? Es wird eine neue PIN erstellt.",
    sendPinMsg: "Möchten Sie den Zugangscode erstellen und über die verfügbaren Kanäle senden?",
    sendDigitalAccessHeader: "Digitalen Zugang senden",
    sendPinHeader: "Zugangs-PIN senden",
    send: "Senden",
    accessLinkSent: "Zugangslink an den Gast gesendet",
    accessSentTitle: "Zugang gesendet",
    successSummary: "Erfolg",
    digitalAccessSentDetail: "Der digitale Zugang wurde für {count} Gerät(e) gesendet",
    ttlockCodesGenerated: "{count} TTLock-Codes wurden für die Buchung erstellt und verarbeitet.",
    accessCodeResent: "Zugangscode erneut gesendet: {code}",
    accessCodeGeneratedSent: "Zugangscode erstellt und gesendet: {code}",
    pinSentTitle: "PIN gesendet",
    pinProcessedDetail: "Die PIN wurde für {count} Schloss/Schlösser verarbeitet",
    pinProcessedBlebox: "und {count} elektronische Tür(en)",
    couldNotSendAccessCode: "Der Zugangscode konnte nicht gesendet werden",
    codeCopied: "Code in die Zwischenablage kopiert",
    mainGate: "Haupteingang",
    accommodation: "Unterkunft",
    doorLabel: "Tür der Unterkunft",
    validUntil: "Gültig bis: {date}",
    earlyAccessLinkMsg:
      "Damit wird der Zugangslink sofort aktiviert (vor der üblichen Check-in-Zeit).",
    earlyAccessPinMsg: "Damit wird die PIN sofort aktiviert (vor der üblichen Check-in-Zeit).",
    earlyAccessHeader: "Früher Zugang",
    activate: "Aktivieren",
    earlyAccessActivated: "Früher Zugang aktiviert",
    okSummary: "OK",
    earlyAccessActivatedDetail: "Der frühe Zugang wurde aktiviert",
    couldNotActivateEarlyAccess: "Der frühe Zugang konnte nicht aktiviert werden",
    cancelReservationMsg:
      "Die Buchung wird vollständig storniert. Wenn sie mehrere Zimmer belegt (auch unterschiedlicher Typen), werden alle storniert und freigegeben. Diese Aktion lässt sich nicht rückgängig machen.",
    goBack: "Zurück",
    resolveOverbookingMsg:
      "Es wird geprüft, ob kein Konflikt mit einer anderen Buchung mehr besteht. Ist der Zeitraum frei, wird die Buchung bestätigt und ihre Daten bleiben auf den OTAs gesperrt.",
    confirmOverbookingHeader: "Buchung im Overbooking bestätigen",
    reservationConfirmed: "Buchung bestätigt.",
    couldNotConfirmReservation: "Die Buchung konnte nicht bestätigt werden.",
    reservationCancelledFreed: "Buchung storniert. {count} Zimmer wurden freigegeben.",
    otaLangPrompt:
      "Diese OTA-Buchung hat keine Telefonnummer. Geben Sie die Sprache der Nachricht an, um den Check-in über den OTA-Chat zu senden: es, en, fr, pt, ar, it, de",
    inviteProcessedEmailOta: "Einladung verarbeitet. Auch per E-Mail und OTA-Chat gesendet.",
    inviteProcessedOta: "Einladung verarbeitet. Auch per OTA-Chat gesendet.",
    inviteProcessedEmail: "Einladung verarbeitet. Auch per E-Mail gesendet.",
    couldNotSendCheckinInvite: "Die Check-in-Einladung konnte nicht gesendet werden",
    couldNotLoadConversations: "Die Konversationen konnten nicht geladen werden",
    reservationUpdatedShort: "Buchung aktualisiert",
    couldNotUpdateReservation: "Die Buchung konnte nicht aktualisiert werden",
    codeEmpty: "Der Code darf nicht leer sein",
    attentionTitle: "Achtung",
    accessCodeProcessed: "Zugangscode erfolgreich verarbeitet",
    sentCheckTitle: "Gesendet ✓",
    accessCodeSendProcessed: "Der Versand des Zugangscodes wurde verarbeitet.",
    couldNotSendCode: "Der Code konnte nicht gesendet werden",
    chatOta: "OTA-Chat",
    emailChannel: "E-Mail",
    channelsUsed: "Verwendete Kanäle: {channels}.",
  },

  // ── HotelReservationModal.vue ─────────────────────────────────────────────
  telefonoDelHuesped: {
    noValido: "Diese Telefonnummer scheint für {pais} nicht gültig zu sein. Wenn der Gast aus einem anderen Land kommt, ändern Sie die Flagge. Klicken Sie erneut auf Speichern, um sie trotzdem zu behalten.",
  },
  hotelResModal: {
    otaBanner:
      "OTA-Buchung: <strong>Daten</strong>, <strong>Typ</strong> und <strong>Zimmeranzahl</strong> können in WA Checkin nicht geändert werden. Das müssen Sie in der OTA tun (Booking, Airbnb usw.).",
    otaLock: "OTA-Buchung: Daten, Typ und Anzahl können nur in der OTA geändert werden.",
    close: "Schließen",
    placeholderEmail: "email@beispiel.com",
    roomAbbr: "Zimmer",
    fromCalendar: "aus dem Kalender",
    noMatches: "Keine Treffer",
    undo: "Rückgängig",
    removeRoom: "Zimmer entfernen",
    willBeRemovedOnSave: "Es wird entfernt, sobald Sie die Änderungen speichern.",
    checkingAvailability: "Verfügbarkeit wird geprüft…",
    availableCount: "{count} verfügbar | {count} verfügbar",
    notEnoughAvail: "Nicht genügend Verfügbarkeit",
    freeCount: "{count} frei | {count} frei",
    total: "gesamt",
    nightsCount: "{count} Nacht | {count} Nächte",
    resendConfirmationTitle: "Bestätigungsnachricht erneut senden",
    resendConfirmationSub: "Sendet die Bestätigungsvorlage erneut an den Gast.",
    resendConfirmationNote:
      "Wenn Sie die Buchung ändern, wird die <strong>Bestätigungsvorlage</strong> für diese Buchung erneut gesendet.",
    room: "Zimmer",

    noEnoughUnitsFree: "Nicht genügend Verfügbarkeit. Freie Einheiten: {units}.",
    closedPeriodManual: "Der Zeitraum enthält Tage, die vom Eigentümer gesperrt wurden.",
    noAvailForDates: "Keine Verfügbarkeit für diese Daten.",
    selectRoomType: "Wählen Sie einen Zimmertyp.",
    selectValidDates: "Wählen Sie gültige Daten.",
    enterGuestName: "Geben Sie den Namen des Gastes ein.",
    invalidEmail: "Die E-Mail ist ungültig.",
    enterValidPhone: "Geben Sie eine gültige Telefonnummer ein.",
    noAvailCreateModify: "Keine Verfügbarkeit, um mit diesen Daten zu erstellen/ändern.",
    aRoom: "ein Zimmer",
    notEnoughAvailIn: "Nicht genügend Verfügbarkeit in: {names}.",
    missingOnCreate: "onCreateReservation fehlt in der übergeordneten Komponente.",
    aRoomType: "ein Zimmertyp",
    notEnoughAvailInType: `Nicht genügend Verfügbarkeit in "{name}".`,
    sameHotelOnly: "Eine Buchung kann keine Zimmer aus zwei Hotels mischen. Entferne die, die nicht zu diesem Hotel gehören.",
    otherHotelLinesDropped: "Die Zimmer des vorherigen Hotels wurden entfernt: Eine Buchung gehört zu einem einzigen Hotel.",
    partiallyCreated: "{ok} von {total} Zimmern wurden angelegt, das nächste schlug fehl. Prüfe die Buchung, bevor du es erneut versuchst.",
    reservationIdNotFound: "Buchungs-ID nicht gefunden.",
    cannotRemoveAll: "Sie können nicht alle Zimmer entfernen. Stornieren Sie dafür die gesamte Buchung.",
    thisRoom: "dieses Zimmer",
    confirmRemoval:
      "Sie ENTFERNEN gleich aus der Buchung: {names}. Diese Zimmer werden freigegeben und nicht mehr berechnet. Fortfahren und speichern?",
    couldNotUpdate: `"{name}" konnte nicht aktualisiert werden.`,
    couldNotRemove: `"{name}" konnte nicht entfernt werden.`,
    couldNotRemovePrimary: "Das Hauptzimmer konnte nicht entfernt werden.",
    reservationUpdated: "Buchung erfolgreich aktualisiert",
    updatedPartially: "Es wurde nur ein Teil gespeichert: Prüfen Sie die Zimmer der Buchung.",
    couldNotUpdateReservation: "Die Buchung konnte nicht aktualisiert werden.",
  },
};
